// extracted by mini-css-extract-plugin
export default {"logo":"_3-NCM","logoImg":"Z6j57","olxAutos":"Xyn2V","disableClick":"ox-pz"};